export default __webpack_public_path__ + "static/media/warn.472ead5f.svg";